import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedListStateService {
  private _hasDealerAndListNameSpecified: boolean;
  private _hasItemPendingAction = false;

  set hasDealerAndListNameSpecified(value: boolean) {
    this._hasDealerAndListNameSpecified = value;
  }

  get hasDealerAndListNameSpecified() {
    return this._hasDealerAndListNameSpecified;
  }

  set hasItemPendingAction(value: boolean) {
    this._hasItemPendingAction = value;
  }

  get hasItemPendingAction() {
    return this._hasItemPendingAction;
  }
}
